<script lang="ts">
    import { getBorderRadius } from '$lib/global/helper/border-radius';
    import { cn } from '$lib/utils/cn';

    import StripeSetupIncomplete from './StripeSetupIncomplete.svelte';

    import type { Language } from '$lib/types/Language';

    export let stripeSetupIncomplete = false;
    export let language: Language = 'en';

    const placeholderRadius = getBorderRadius('fieldsWrapper');
</script>

<div class="fun-relative">
    <div
        class={cn('fun-grid fun-grid-cols-4 fun-gap-4', {
            'fun-animate-pulse': !stripeSetupIncomplete,
        })}
    >
        <div
            class={cn(
                'fun-col-span-full fun-flex fun-h-14 fun-items-center fun-justify-items-center fun-bg-gray-100',
                placeholderRadius,
            )}
        ></div>

        <div class={cn('fun-col-span-2 fun-h-14 fun-bg-gray-100', placeholderRadius)} />
        <div
            class={cn(
                'fun-col-span-2 fun-flex fun-h-14 fun-items-center fun-justify-between fun-bg-gray-100',
                placeholderRadius,
            )}
        />

        <div class={cn('fun-col-span-full fun-h-14 fun-bg-gray-100', placeholderRadius)} />
    </div>
    {#if stripeSetupIncomplete}
        <div class="fun-absolute fun-inset-0 fun-flex fun-items-center fun-justify-center">
            <StripeSetupIncomplete {language} />
        </div>
    {/if}
</div>
